import { useClient, useDictionary } from "@adamlip/okeoke.client";
import { Select, SelectItem } from "@nextui-org/react";
import moment from "moment";
import nationalities from "./nationalities.json";
import CustomInput from "components/CustomInput";
import phoneCodes from "./phoneCodes.json";
import educationCodes from "./educationCodes.json";
import { useContext, useState, useRef } from "react";
import { UserContext } from "contexts/UserContext";
import { Switch } from "@nextui-org/react";
import { AppParamsContext } from "contexts/AppParamsContext";

export default function VipFieldSwitch({ name }) {
  const { getValue } = useDictionary();
  const { getName } = useClient();
  const { appParams } = useContext(AppParamsContext);
  const { userData, handleChangeUserData } = useContext(UserContext);

  const [errors, setErrors] = useState({});

  const phoneCodeRef = useRef();

  phoneCodeRef.current = [
    ...new Set(
      phoneCodes
        .sort((a, b) => (a.dial_code > b.dial_code ? 1 : -1))
        .map((row) => row.dial_code)
    ),
  ];

  const checkDate = (e) => {
    let date = e.target.value;
    let newValues = { ...errors };

    if (new Date(date) !== "Invalid Date" && !isNaN(new Date(date))) {
      delete newValues?.birthdate;
    } else {
      newValues.birthdate = "app_v2_profile_error_invalidBirthdate";
    }

    setErrors(newValues);
  };

  if (name === "firstName")
    return (
      <CustomInput
        name="firstName"
        label={getValue("app_v2_profile_nickname")}
        value={userData?.firstName || ""}
        onChange={handleChangeUserData}
      />
    );

  if (name === "lastName")
    return (
      <CustomInput
        name="lastName"
        label={getValue("app_v2_profile_lastName")}
        value={userData?.lastName || ""}
        onChange={handleChangeUserData}
      />
    );

  if (name === "birthDate")
    return (
      <CustomInput
        type="date"
        name="birthDate"
        className={"birthdate-field "}
        label={getValue("app_v2_profile_birthdate")}
        value={
          userData?.birthDate
            ? moment(userData?.birthDate).format("YYYY-MM-DD")
            : ""
        }
        onChange={handleChangeUserData}
        onBlur={checkDate}
        helperText={
          errors?.birthdate != null ? getValue(errors?.birthdate) : ""
        }
        error={errors?.birthdate != null}
        disableFloat
        onCancel={() =>
          handleChangeUserData({ target: { name: "birthDate", value: null } })
        }
      />
    );
  if (name === "nameDay")
    return (
      <CustomInput
        type="date"
        name="nameDay"
        className={"birthdate-field "}
        label={getValue("app_v2_profile_nameDay")}
        value={
          userData?.nameDay
            ? moment(userData?.nameDay).format("YYYY-MM-DD")
            : ""
        }
        onChange={handleChangeUserData}
        onBlur={checkDate}
        helperText={errors?.nameDay != null ? getValue(errors?.nameDay) : ""}
        error={errors?.nameDay != null}
        disableFloat
        onCancel={() =>
          handleChangeUserData({ target: { name: "nameDay", value: null } })
        }
      />
    );
  if (name === "zip")
    return (
      <CustomInput
        name="zip"
        label={getValue("app_v2_profile_zip")}
        value={userData?.zip || ""}
        onChange={handleChangeUserData}
      />
    );
  if (name === "gender")
    return (
      <Select
        aria-label="12"
        name="gender"
        classNames={{
          label: `${
            appParams?.styles?.fonts?.capitalize ? "font-bold uppercase" : ""
          } group-data-[filled=true]:text-[var(--button-bg-color)] text-[var(--button-bg-color)] `,
          value: `${
            appParams?.styles?.fonts?.capitalize ? "font-bold uppercase" : ""
          }`,
          trigger: "bg-[var(--input-bg-color)]",
        }}
        selectedKeys={userData?.gender ? [userData?.gender.toString()] : ["0"]}
        label={getValue("app_v2_profile_gender")}
        onChange={handleChangeUserData}
      >
        <SelectItem
          aria-label="1"
          key={"1"}
          value={"1"}
          textValue={getValue("app_v2_profile_male")}
          className={
            appParams?.styles?.fonts?.capitalize ? "font-bold uppercase" : ""
          }
        >
          {getValue("app_v2_profile_male")}
        </SelectItem>
        <SelectItem
          aria-label="2"
          key={"2"}
          value={"2"}
          textValue={getValue("app_v2_profile_female")}
          className={
            appParams?.styles?.fonts?.capitalize ? "font-bold uppercase" : ""
          }
        >
          {getValue("app_v2_profile_female")}
        </SelectItem>
        {!appParams?.profile?.hideOtherGender && (
          <SelectItem
            aria-label="3"
            key={"3"}
            value={"3"}
            textValue={getValue("app_v2_profile_other")}
            className={
              appParams?.styles?.fonts?.capitalize ? "font-bold uppercase" : ""
            }
          >
            {getValue("app_v2_profile_other")}
          </SelectItem>
        )}
        <SelectItem
          aria-label="0"
          key={"0"}
          value={"0"}
          textValue={getValue("app_v2_profile_no_gender")}
          className={
            appParams?.styles?.fonts?.capitalize ? "font-bold uppercase" : ""
          }
        >
          {getValue("app_v2_profile_no_gender")}
        </SelectItem>
      </Select>
    );
  if (name === "nationality")
    return (
      <Select
        aria-label="12"
        name="nationality"
        classNames={{
          label: `${
            appParams?.styles?.fonts?.capitalize ? "font-bold uppercase" : ""
          } group-data-[filled=true]:text-[var(--button-bg-color)] text-[var(--button-bg-color)]`,
          value: appParams?.styles?.fonts?.capitalize
            ? "font-bold uppercase"
            : "",
          trigger: "bg-[var(--input-bg-color)]",
        }}
        selectedKeys={
          userData?.nationality
            ? [userData?.nationality.toString()]
            : ["Hungarian"]
        }
        label={getValue("app_v2_profile_nationality")}
        onChange={handleChangeUserData}
      >
        {nationalities.map((nat) => (
          <SelectItem
            aria-label={nat}
            key={nat}
            value={nat}
            textValue={nat}
            className={
              appParams?.styles?.fonts?.capitalize ? "font-bold uppercase" : ""
            }
          >
            {nat}
          </SelectItem>
        ))}
      </Select>
    );
  if (name === "telNumber")
    return (
      <div className="flex items-center gap-2">
        <Select
          aria-label="12"
          name="dialCode"
          classNames={{
            label: `${
              appParams?.styles?.fonts?.capitalize ? "font-bold uppercase" : ""
            } group-data-[filled=true]:text-[var(--button-bg-color)] text-[var(--button-bg-color)]`,
            value: appParams?.styles?.fonts?.capitalize
              ? "font-bold uppercase"
              : "",
            trigger: "bg-[var(--input-bg-color)]",
          }}
          label={getValue("app_v2_profile_dial_code")}
          selectedKeys={
            userData?.dialCode ? [userData?.dialCode.toString()] : ["+36"]
          }
          onChange={handleChangeUserData}
        >
          <SelectItem
            aria-label="+36"
            key={"+36"}
            value={"+36"}
            textValue={"+36"}
            className={
              appParams?.styles?.fonts?.capitalize ? "font-bold uppercase" : ""
            }
          >
            {"+36"}
          </SelectItem>
          {phoneCodeRef.current.map((row) => (
            <SelectItem
              aria-label={row}
              key={row}
              value={row}
              textValue={row}
              className={
                appParams?.styles?.fonts?.capitalize
                  ? "font-bold uppercase"
                  : ""
              }
            >
              {row}
            </SelectItem>
          ))}
        </Select>
        <CustomInput
          name="phoneNumber"
          label={getValue("app_v2_profile_telNumber")}
          value={userData?.phoneNumber || ""}
          onChange={handleChangeUserData}
          fullWidth={false}
        />
      </div>
    );
  if (name === "education")
    return (
      <Select
        aria-label="12"
        name="education"
        classNames={{
          label: `${
            appParams?.styles?.fonts?.capitalize ? "font-bold uppercase" : ""
          } group-data-[filled=true]:text-[var(--button-bg-color)] text-[var(--button-bg-color)]`,
          value: appParams?.styles?.fonts?.capitalize
            ? "font-bold uppercase"
            : "",
          trigger: "bg-[var(--input-bg-color)]",
        }}
        label={getValue("app_v2_profile_education")}
        selectedKeys={
          userData?.education ? [userData?.education.toString()] : ["0"]
        }
        onChange={handleChangeUserData}
      >
        {educationCodes.map((row) => (
          <SelectItem
            aria-label={row.code}
            key={row.code}
            value={row.code}
            textValue={getName(row.name)}
            className={
              appParams?.styles?.fonts?.capitalize ? "font-bold uppercase" : ""
            }
          >
            {getName(row.name)}
          </SelectItem>
        ))}
      </Select>
    );
  if (name === "anniversary")
    return (
      <CustomInput
        type="date"
        name="anniversary"
        className={"birthdate-field "}
        label={getValue("app_v2_profile_anniversary")}
        value={
          userData?.anniversary
            ? moment(userData?.anniversary).format("YYYY-MM-DD")
            : ""
        }
        onChange={handleChangeUserData}
        onBlur={checkDate}
        helperText={
          errors.anniversary != null ? getValue(errors.anniversary) : ""
        }
        error={errors.anniversary != null}
        disableFloat
        onCancel={() =>
          handleChangeUserData({ target: { name: "anniversary", value: null } })
        }
      />
    );
  if (name === "newsletter")
    return (
      <div className="">
        <Switch
          isSelected={userData?.newsletter}
          onValueChange={() =>
            handleChangeUserData({
              target: {
                name: "newsletter",
                value: userData?.newsletter ? false : true,
              },
            })
          }
        >
          {getValue("app_v2_profile_newsletter")}
        </Switch>
      </div>
    );
  return null;
}
